import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';

import Root from './Root.component';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const { bootstrap, mount, unmount } = singleSpaReact({
    React,
    // dynamic support for react 17/18
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ...(ReactDOM?.createRoot ? { ReactDOMClient: ReactDOM } : { ReactDOM }),
    rootComponent: Root,
    errorBoundary(err, errInfo) {
        // eslint-disable-next-line no-console
        console.log('cloud-nav: unhandled error', err, errInfo);
        return React.createElement('div');
    },
});
